import React from "react";

const KHeader = () => {
  return (
    <>
      <div className="header">
        <img src="/images/logo-icon.png" alt="logo" width="70" height="50" />
        <h1>K@j@! Notes</h1>
      </div>
    </>
  );
};
export default KHeader;
